  function readMore() {
    var moreText = document.getElementById("TTAmore");
    var btnText = document.getElementById("readMoreBtn");

    if (moreText.style.display === "none" || moreText.style.display === "") {
      moreText.style.display = "block";
      btnText.innerHTML = "Read less -";
    } else {
      moreText.style.display = "none";
      btnText.innerHTML = "Read more +";
    }
  }

  // Initially hide the extra content
  document.addEventListener("DOMContentLoaded", function () {
    document.getElementById("TTAmore").style.display = "none";
  });
